import { ErrorOutlined } from "@mui/icons-material";
import { Box, Grid, MenuItem, Stack } from "@mui/material";
import React, { useState, useEffect } from "react";
import { COLORS } from "../../assets/colors";
import Dimens from "../../assets/Dimens";
import {
  DefaultDropdown,
  DefaultTextField,
  StyledBodyText,
  StyledCaptionText,
} from "../common";
import DefaultButton from "./DefaultButton";
import PropTypes from "prop-types";
import MedicationRefilItem from "./MedicationRefilItem";
import moment from "moment";
import { useTranslation } from "react-i18next";

const SurgeryForm = (props) => {
  const { handleSubmit, surgeryArray, onDeleteClick, onEditClick, clearSurgeryForm } = props;
  const [surgery, setSurgery] = useState({
    name: "",
    description: "",
    procedureDate: "",
  });

  const {t} = useTranslation("translations")

  const clearForm = () => {
    setSurgery({
    name: "",
    description: "",
    procedureDate: "",
  })
  }

  useEffect(() => {
    clearSurgeryForm.current = clearForm
  }, [])

  useEffect(() => {
    if (surgery.name && surgery.description && surgery.procedureDate) {
      setAddRefillDisabled(false);
    } else {
      setAddRefillDisabled(true);
    }
  }, [surgery.name, surgery.description, surgery.procedureDate]);
  const [addRefillDisabled, setAddRefillDisabled] = useState(false);
  const handleChange = (key, value) => {
    setSurgery({ ...surgery, [key]: value });
  };
  return (
    <Box>
      <StyledBodyText sx={{ mt: 2 }}>Procedures</StyledBodyText>
      <Box
        sx={{
          mt: 2,
          width: "100%",
          pt: 1,
          pb: 1,
          pl: 1,
          bgcolor: COLORS.PRIMARY_MAIN,
          borderRadius: Dimens.BORDER_RADIUS_MEDIUM,
        }}
      >
        <Stack direction="row" alignItems="center">
          <ErrorOutlined />
          <StyledCaptionText sx={{ fontSize: Dimens.FONT_SIZE_SMALL, ml: 2 }}>
           {t("add_one_surgery_at_time")}
          </StyledCaptionText>
        </Stack>
      </Box>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <StyledBodyText sx={{ fontSize: Dimens.FONT_SIZE_SMALL }}>
            {t("procedure_name")}
          </StyledBodyText>
          <DefaultTextField
            id="procedure"
            value={surgery.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledBodyText sx={{ fontSize: Dimens.FONT_SIZE_SMALL }}>
            {t("date")}
          </StyledBodyText>
          <DefaultTextField
            type={"date"}
            max={moment(new Date()).format("dd/MM/yyyy")}
            value={surgery.procedureDate}
            id="procedureDate"
            onChange={(e) => handleChange("procedureDate", e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <StyledBodyText sx={{ fontSize: Dimens.FONT_SIZE_SMALL }}>
            {t("description")}
          </StyledBodyText>
          <DefaultTextField
            value={surgery.description}
            id="description"
            multiline
            minRows={2}
            onChange={(e) => handleChange("description", e.target.value)}
          />
        </Grid>
      </Grid>
      <Stack alignItems={"center"} sx={{ mt: 2, mb: 3 }}>
        <DefaultButton
          sx={{ bgcolor: COLORS.BUTTON_SECONDARY }}
          disabled={addRefillDisabled}
          onClick={() => handleSubmit(surgery)}
        >
          {t("add_procedure")}
        </DefaultButton>
      </Stack>
      {surgeryArray.map((el, index) => (
        <MedicationRefilItem
          medicationName={el.medicationName || el.name}
          comment={el.comment || el.description}
          procedureDate={el.procedureDate}
          frequency={el.frequency}
          onDeleteClick={() => onDeleteClick(index)}
          onEditClick={() => onEditClick(index)}
        />
      ))}
    </Box>
  );
};
SurgeryForm.propTypes = {
  handleSubmit: PropTypes.func,
  surgeryArray: PropTypes.array,
  onDeleteClick: PropTypes.func,
  onEditClick: PropTypes.func,
  clearSurgeryForm: PropTypes.object
};

export default SurgeryForm;
